import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  Cell,
} from "recharts";

type CustomBarChartProps = {
  data: { name: string; date: string; consumption: number; entryId: number }[];
  handleEntrySelect: (entryId: number) => void;
  selectedEntryId?: number | null;
};

const COLORS = {
  default: "#f04684",
  selected: "#3164f4",
};

type CustomTickProps = {
  x?: number;
  y?: number;
  payload?: { value: string; index: number };
  data: CustomBarChartProps["data"];
};

function CustomXAxisTick({ x, y, payload, data }: CustomTickProps) {
  const index = payload?.index ?? 0;
  const date = data[index]?.date || "";

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={12} textAnchor="middle" fill="#666" fontSize={12}>
        {payload?.value}
      </text>
      <text x={0} y={0} dy={26} textAnchor="middle" fill="#999" fontSize={10}>
        {date}
      </text>
    </g>
  );
}

export default function CustomBarChart({
  data,
  handleEntrySelect,
  selectedEntryId,
}: CustomBarChartProps) {
  return (
    <ResponsiveContainer height={220} width={"100%"}>
      <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          tick={(props) => <CustomXAxisTick {...props} data={data} />}
          height={45}
        />
        <YAxis tick={{ fontSize: 10 }} width={45} />
        <Tooltip />
        <Legend verticalAlign="top" height={36} />
        <Bar
          dataKey="consumption"
          onClick={(e) => {
            handleEntrySelect(e.entryId);
          }}
          style={{ cursor: "pointer" }}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                entry.entryId === selectedEntryId
                  ? COLORS.selected
                  : COLORS.default
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
